/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseDocumentDto } from '../../models/response-document-dto';
import { UpdateDocumentDto } from '../../models/update-document-dto';

export interface DocumentsControllerUpdateDocument$Params {

/**
 * Tenant ID
 */
  tenant: string;

/**
 * Document unique identifier
 */
  documentId: string;
      body: UpdateDocumentDto
}

export function documentsControllerUpdateDocument(http: HttpClient, rootUrl: string, params: DocumentsControllerUpdateDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseDocumentDto>> {
  const rb = new RequestBuilder(rootUrl, documentsControllerUpdateDocument.PATH, 'put');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('documentId', params.documentId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseDocumentDto>;
    })
  );
}

documentsControllerUpdateDocument.PATH = '/thalea-documents/documents/{tenant}/{documentId}';
